import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 bg-[#0a0f1a]" data-id="element-148">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <FadeIn data-id="element-150">
          <div className="bg-gradient-to-br from-[#111827] to-[#0a0f1a] border border-cyan-500/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-151">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-cyan-500 to-transparent opacity-50" data-id="element-152" />

            <ShieldCheck className="w-16 h-16 text-cyan-400 mx-auto mb-6" data-id="element-153" />

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-154">
              La regla de los <span className="text-cyan-400" data-id="element-155">7 días</span>
            </h2>

            <p className="text-xl md:text-2xl text-[#d1d5db] leading-relaxed mb-8" data-id="element-156">
              En menos de una semana aplicando este manual, habrás recuperado al
              menos <strong className="text-white" data-id="element-157">8 horas de tu tiempo</strong>
              .
            </p>

            <p className="text-lg text-slate-400 leading-relaxed max-w-2xl mx-auto" data-id="element-158">
              No es magia, es eficiencia algorítmica aplicada a la burocracia
              humana. Empezarás a entregar en minutos lo que antes te tomaba una
              mañana entera.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}